import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children?: ReactNode;
  modalContentClassName?: string;
  "data-testid"?: string;
}

const Modal = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  modalContentClassName,
  "data-testid": dataTestId,
}: Props) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        showCloseButton={false}
        className={modalContentClassName}
        data-testid={dataTestId}
      >
        <DialogHeader className="">
          <DialogTitle className="text-center text-h2! font-semibold text-heading">
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription className="text-center text-base! text-body leading-3xl font-normal">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
